import ButtonComponent from '@pretto/bricks/components/buttons/Button'
import * as helpers from '@pretto/bricks/components/helpers'
import { breakpoints, g } from '@pretto/bricks/components/layout'
import ResponsiveSSR from '@pretto/bricks/components/utility/ResponsiveSSR'
import * as typo from '@pretto/bricks/core/typography'

import styled from 'styled-components'

export const Card = styled.div`
  ${helpers.boxShadow('card')};
  background-color: ${({ theme }) => theme.colors.primary1};
  color: ${({ theme }) => theme.colors.white};
  border-radius: ${g(1)};
  padding: ${g(2)} ${g(3)};
  position: relative;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${g(4)};
  }
`
export const Result = styled.div`
  display: grid;
  grid-gap: ${g(3)};
  grid-template-columns: repeat(2, 1fr);
`
export const Highlight = styled.div`
  ${typo.heading48};
  ${typo.isNumber};
  white-space: nowrap;
`
export const Value = styled.div`
  ${typo.heading32};
  ${typo.isNumber};
  display: flex;
  align-items: center;
`
export const Suffix = styled.span`
  ${typo.bodyBook16};
  margin-left: ${g(1)};
`
export const Divider = styled(ResponsiveSSR).attrs({ min: 'tablet' })`
  display: block;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.white};
  margin: ${g(4)} 0;
`
export const Button = styled(ButtonComponent).attrs({ isSecondary: true })`
  margin: ${g(3)} 0;
`
